module.exports = __webpack_public_path__ + "img/nextsteps.37c56c49.jpg";